<template>
  <transition name="fade">
    <div v-if="isOpen" class="overlay" @click.self="close">
      <div class="overlay-content content">
        <button
          class="close-btn"
          type="button"
          ref="close"
          @click="close"
          :aria-label="$t('Close')"
        >
          <i class="icon-close"></i>
        </button>
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'

export default {
  name: 'Overlay',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  mixins: [ReadyHook],
  watch: {
    isOpen(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.$refs.close.focus()
        }, 100)
        document.body.style.overflowY = 'hidden'
        document.addEventListener('keydown', this.handleEsc)
      } else {
        document.body.style.overflowY = 'auto'
        document.removeEventListener('keydown', this.handleEsc)
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    handleEsc(event) {
      if (event.key === 'Escape') {
        this.close()
      }
    },
    trapFocus(e) {
      if (
        this.isOpen &&
        !(this.$el === e.target || this.$el.contains(e.target)) &&
        (!e.target.classList || !e.target.classList.contains('overlay'))
      ) {
        this.$refs.close.focus()
      }
    }
  },
  mounted() {
    document.addEventListener('keyup', this.handleEsc)
    document.addEventListener('focus', this.trapFocus, true)
  },
  destroyed() {
    document.removeEventListener('keyup', this.handleEsc)
    document.removeEventListener('focus', this.trapFocus, true)
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 2000;

  &-content {
    width: 100%;
    max-width: 500px;
    height: 100%;
    background-color: var(--zenith-white);
    overflow-y: auto;
    .close-btn {
      border: none;
      background: none;
      position: absolute;
      top: 10px;
      right: 10px;
      padding: 0%;
      filter: none !important;
    }
  }
}

/* Background Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
/* Overlay Slide-in/out Transition */
.fade-enter-active .overlay-content,
.fade-leave-active .overlay-content {
  transition: transform 0.3s ease-in-out;
}
.fade-enter .overlay-content,
.fade-leave-to .overlay-content {
  transform: translateX(100%);
}
</style>
